export default __webpack_public_path__ + "static/media/ic_close_white.fec50fc1.svg";